/*!
 * SPDX-FileCopyrightText: 2025 Nextcloud GmbH and Nextcloud contributors
 * SPDX-License-Identifier: AGPL-3.0-or-later
 */
/**
 * The current status of the filename sanitization
 */
export var SanitizeFilenameStatus;
(function (SanitizeFilenameStatus) {
    SanitizeFilenameStatus[SanitizeFilenameStatus["Unknown"] = 0] = "Unknown";
    SanitizeFilenameStatus[SanitizeFilenameStatus["Scheduled"] = 1] = "Scheduled";
    SanitizeFilenameStatus[SanitizeFilenameStatus["Running"] = 2] = "Running";
    SanitizeFilenameStatus[SanitizeFilenameStatus["Done"] = 3] = "Done";
    SanitizeFilenameStatus[SanitizeFilenameStatus["Error"] = 4] = "Error";
})(SanitizeFilenameStatus || (SanitizeFilenameStatus = {}));
